






















import BaseModal from "@web-components/components/BaseModal.vue";

import { createComponent } from "@vue/composition-api";

interface BaseStandardModal {
  show: boolean;
  renderTo: string;
}

export default createComponent({
  components: {
    BaseModal
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    renderTo: {
      type: String,
      required: true
    },
    isWarning: {
      type: Boolean,
      default: true
    }
  },
  setup(props: Readonly<BaseStandardModal>, context) {}
});
